import React, { useState, useEffect } from "react";
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { obtenerLibrosSliders } from "../../services/LibrosService";
import BookItem from "./bookItem";
import './booksSlider.css';

function BooksSlider({ tipo, idFondo, nombreFondo, isAcademic }) {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLibrosData = async () => {
      setLoading(true);
      if (idFondo && typeof isAcademic !== 'undefined') {
        const idCategoria = isAcademic ? 1 : 2; // 1 para Académico, 2 para Literatura
        const response = await obtenerLibrosSliders(idFondo, idCategoria);
        setBooks(response.content || response.data || response);
      }
      setLoading(false);
    };

    fetchLibrosData();
  }, [tipo, idFondo, isAcademic]);


    // No renderizar el slider si no hay libros disponibles
  if (!loading && books.length === 0) {
    return null;
  }

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <MdArrowBackIos {...props} color="gray" style={{ width: '2rem', height: '2rem' }} />
  );

  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <MdArrowForwardIos {...props} color="gray" style={{ width: '2rem', height: '2rem' }} />
  );

  // Configuración de las opciones del carrusel
  const sliderSettings = {
    dots: false,
    arrows: tipo === 'relacionados' ? false : true,
    infinite: books.length > 5, // Solo infinito si hay más de 8 libros
    speed: 500,
    slidesToShow: Math.min(5, books.length), // Mostrar el menor entre 8 y la cantidad de libros
    slidesToScroll: Math.min(5, books.length), // Desplazar el menor entre 8 y la cantidad de libros
    nextArrow: tipo === 'relacionados' ? null : <SlickArrowRight />,
    prevArrow: tipo === 'relacionados' ? null : <SlickArrowLeft />,
    responsive: [
      {
        breakpoint: 1620,
        settings: {
          slidesToShow: Math.min(5, books.length),
          slidesToScroll: Math.min(5, books.length),
        }
      },
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: Math.min(4, books.length),
          slidesToScroll: Math.min(4, books.length),
        }
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: Math.min(3, books.length),
          slidesToScroll: Math.min(3, books.length),
        }
      },
      {
        breakpoint: tipo === 'relacionados' ? 980 : 800,
        settings: {
          slidesToShow: Math.min(2, books.length),
          slidesToScroll: Math.min(2, books.length),
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: Math.min(1, books.length),
          slidesToScroll: Math.min(1, books.length),
        }
      },
    ]
  };

  return (
    <div className={tipo === 'relacionados' ? "booksSlider-container-relacionados" : "booksSlider-container"}>
      <h3>{tipo === 'relacionados' ? 'También te podría gustar' : nombreFondo}</h3>
      <Slider {...sliderSettings}>
        {loading ? [...new Array(5)].map((book, index) => (
          <div key={index}>
            <BookItem bookData={book} loading={loading} tipo={tipo} />
          </div>
        )) : books.map((book) => (
          <div key={book.idLibro}>
            <BookItem bookData={book} loading={loading} tipo={tipo} />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default BooksSlider;

